import Vue from "vue"
import Router from "vue-router"
import Register from '../views/Register/Register.vue'
import Success from '../views/Register/Success.vue'
import Confirm from '../views/Register/Confirm.vue'
import ForgotPassword from '../views/ForgotPassword/ForgotPassword.vue'
import ForgotPasswordConfirm from '../views/ForgotPassword/Confirm.vue'
import ForgotPasswordSuccess from '../views/ForgotPassword/Success.vue'
import Login from '../views/Register/Login.vue'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import MyProfile from '../views/MyProfile/MyProfile.vue'
import MarketRates from '../components/Cards/MarketRatesCards.vue'
import Indexes from '../views/Indexes/Indexes.vue'
import FixedTerm from '../views/FixedTerm/FixedTerm.vue'
import BugReport from '../views/BugReport/BugReport.vue'
import Donations from '../views/Donations/Donations.vue'
import TermsAndConditions from '../components/Footers/TermsAndConditions.vue'
import PrivacyPolicy from '../components/Footers/PrivacyPolicy.vue'
import NotFound from '../components/Misc/NotFound.vue';
import InConstrunction from '../components/Misc/InConstruction.vue';

import store from "../store"

Vue.use(Router)

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "Home",
            component: Home,
        },
        {
            path: "/Register",
            name: "Register",
            component: Register
        },
        {
            path: "/Register/Success",
            name: "Success",
            component: Success
        },
        {
            path: "/Register/Confirm",
            name: "Confirm",
            component: Confirm
        },
        {
            path: "/ForgotPassword",
            name: "ForgotPassword",
            component: ForgotPassword
        },
        {
            path: "/ForgotPassword/Confirm",
            name: "ForgotPasswordConfirm",
            component: ForgotPasswordConfirm
        },
        {
            path: "/ForgotPassword/Success",
            name: "ForgotPasswordSuccess",
            component: ForgotPasswordSuccess
        },
        {
            path: "/Login",
            name: "Login",
            component: Login
        },
        {
            path: "/About",
            name: "About",
            component: About,
        },
        {
            path: "/Donations",
            name: "Donations",
            component: Donations,
        },
        {
            path: "/Currencies",
            name: "Currencies",
            component: MarketRates,
        },
        {
            path: "/History",
            name: "History",
            component: InConstrunction,
        },
        {
            path: "/BugReport",
            name: "BugReport",
            component: BugReport,
        },
        {
            path: "/Indexes",
            name: "Indexes",
            component: Indexes,
        },
        {
            path: "/FixedTerm",
            name: "FixedTerm",
            component: FixedTerm,
        },
        {
            path: "/TermsAndConditions",
            name: "TermsAndConditions",
            component: TermsAndConditions,
        },
        {
            path: "/PrivacyPolicy",
            name: "PrivacyPolicy",
            component: PrivacyPolicy,
        },
        {
            path: "/MyProfile",
            name: "MyProfile",
            component: MyProfile,
        },
        {
            path: '*',
            name: 'NotFound',
            component: NotFound,
        },
    ]
})

router.beforeEach((to, from, next) => {
    const protectedRoute = to.matched.some(record => record.meta.requireAuth);
    
    if (protectedRoute && store.state.token === '') {
        next({ name: "Login" });
    } else {
        next();
    }
})

export default router